<!-- HelpModal.vue -->
<template>
  <div class="modal-container">
    <img
      src="images/close.svg"
      class="close"
      @click="resetModal"
      role="button"
      aria-label="Close"
      alt="X to close modal"
      title="Close"
    />
    <div class="modal-content">
      <div class="modal-main">
        <div class="centered-text">
          <img
            src="images/heart_blue.svg"
            class="page-icon"
            alt="heart"
            title="Games We Love"
          />
          <h2>Games We Love</h2>
        </div>
        <div class="centered-text">
          Not done puzzling?<br />These games are ready when you are.
        </div>
        <div class="game-grid">
          <a
            class="game-cell"
            v-for="(game, index) in partnerGames"
            :key="index"
            :href="game.url"
            target="_blank"
            @click="
              trackEvent('Partner Games', { title: game.name, mode: 'index' })
            "
          >
            <div
              class="image-container"
              :style="{ backgroundColor: game.color }"
            >
              <img
                :src="game.image_url"
                :alt="game.name + ' Logo'"
                :title="'Click to play ' + game.name"
              />
            </div>
            <div class="game-title">
              {{ game.name }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerGamesModal",
  inject: ["trackEvent"],
  props: {
    resetModal: {
      type: Function,
      required: true,
    },
    partnerGames: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
h2,
h3 {
  text-align: center;
}
.page-icon {
  height: 5vh;
}
.game-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1vh;
  justify-content: center;
  margin: 2vh 0;
}
.game-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 21%;
  flex-direction: column;
  gap: 0.5vh;
  aspect-ratio: 1 / 1;
}
.game-cell .image-container {
  border-radius: 50%;
  width: 80%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.185);
  display: flex;
}

.game-cell .game-title {
  height: 5vh;
  display: flex;
  text-align: center;
}

.image-container img {
  width: 60%;
  display: block;
  margin: auto;
}

.game-cell,
.game-cell:hover,
.game-cell:visited {
  text-decoration: none;
  color: var(--text-color);
}
</style>